<template>
  <div class="case-digital-mlpa-main-data-table-page col-block width-full" :style="{ flex: 1 }">
    <div class="case-digital-mlpa-main-data-table-container col-block width-full" :style="{ flex: 1 }">
      <div class="custom-table" :class="{ 'auto-height': false }">
        <div
          v-if="tableWidths"
          class="table-field col-block grab-container"
          :style="{ width: tableWidths.reduce((s, c) => s + c.value, 0) + 'px' }"
          @mousedown.left="e => boardEvent('board1', e, [boardStart])"
          @mousemove="e => boardEvent('board1', e, [boardMove])"
          @mouseout="e => boardEvent('board1', e, [boardMove])"
          @mouseup.left="e => boardEvent('board1', e, [boardEnd])"
        >
          <!-- line -->
          <!-- <div class="grab-line x min" :style="lineData.x.min && lineData.x.min.display ? { left: lineData.x.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x max" :style="lineData.x.max && lineData.x.max.display ? { left: lineData.x.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x main" :style="lineData.x.main && lineData.x.main.display ? { left: (lineData.x.main.base + lineData.x.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line x custom" :style="lineData.x.custom && lineData.x.custom.display ? { left: lineData.x.custom.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y min" :style="lineData.y.min && lineData.y.min.display ? { top: lineData.y.min.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y max" :style="lineData.y.max && lineData.y.max.display ? { top: lineData.y.max.value + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y main" :style="lineData.y.main && lineData.y.main.display ? { top: (lineData.y.main.base + lineData.y.main.grab) + 'px', display: 'block' } : {}"></div>
          <div class="grab-line y custom" :style="lineData.y.custom && lineData.y.custom.display ? { top: lineData.y.custom.value + 'px', display: 'block' } : {}"></div> -->
          <!-- /line -->
          <div class="table-container col-block">
            <div class="thead">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in topTableOptions"
                  :key="index"
                  class="th row-block"
                  :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                  :style="{ width: tableTopWidths[index].value + tableTopWidths[index].grab + 'px', background: option.background }"
                  @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                >
                  <span class="ellipsis">{{ option.title }}</span>
                  <template v-if="option.sortMap !== null">
                    <div :style="{ width: '5px' }"></div>
                    <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                  </template>
                  <!-- <div
                    v-if="index + 1 > statictableTopWidths[0].length && tableOptions[index + 1 + statictableTopWidths[1].length]"
                    class="grab-box grab-x"
                    :class="{ grabbing: boardData['board1'].grabID === index }"
                    :grab-id="index"
                    :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                    :grab-x-min="tableTopWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                    :grab-x-max="tableTopWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - statictableTopWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - statictableTopWidths[1].reduce((s, c) => s + c, 0) + '*'"
                    :grab-x-custom="tableTopWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                  ></div> -->
                </div>
              </div>
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="[{ sortable: option.sortMap !== null }, (option.class || (() => []))(null, -1, null)]"
                  :style="{ width: tableWidths[index].value + tableWidths[index].grab + 'px' }"
                  @click="e => !sort.disabled && option.sortMap !== null && tableSortBy(option.sortValue || option.value)"
                >
                  <span class="ellipsis">{{ option.title }}</span>
                  <template v-if="option.sortMap !== null">
                    <div :style="{ width: '5px' }"></div>
                    <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true"></i>
                  </template>
                  <!-- <div
                    v-if="index + 1 > staticTableWidths[0].length && tableOptions[index + 1 + staticTableWidths[1].length]"
                    class="grab-box grab-x"
                    :class="{ grabbing: boardData['board1'].grabID === index }"
                    :grab-id="index"
                    :grab-type="'x' + { line: '', grab: '*' }[boardType['board1']]"
                    :grab-x-min="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + (option.minWidth || tableMinWidths) + '*'"
                    :grab-x-max="tableWidths.reduce((s, c) => s + c.value, 0) - tableOptions.slice(index + 1, tableOptions.length - staticTableWidths[1].length).reduce((s, c) => s + (c.minWidth || tableMinWidths), 0) - staticTableWidths[1].reduce((s, c) => s + c, 0) + '*'"
                    :grab-x-custom="tableWidths.slice(0, index).reduce((s, c) => s + c.value, 0) + { line: '', grab: '*' }[boardType['board1']]"
                  ></div> -->
                </div>
              </div>
            </div>
          </div>
          <div ref="custom-table-scroll" class="table-group-container col-block width-full" @mouseleave="e => hoverTableData = null">
            <div class="col-block">
              <div class="table-container col-block" v-for="(group, gindex) in tableDatas" :key="gindex">
                <div class="tbody">
                  <div class="tr group row-block" :class="{ selected: false }" :style="group.title ? {} : { height: 0, 'min-height': 0, 'border-bottom': 0, overflow: 'hidden' }">
                    <a class="container-block row-block">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(group[option.gValue], gindex, group)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template>
                          <span
                            :style="(option.gstyle || (() => ({})))(group[option.gValue], gindex, group)"
                            :title="((option.gdisplay || (x => x))(group[option.gValue], gindex, group) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.gdisplay || (x => x))(group[option.gValue], gindex, group) || option.gempty || ''"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(group[option.gValue], gindex, group).includes('center') && !(option.class || (() => []))(group[option.gValue], gindex, group).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                  </div>
                  <div
                    class="tr col-block"
                    v-for="(data, dindex) in group.datas"
                    :key="dindex"
                    :class="{ selectable: false, selected: (selectData || {})['Probe Number'] === data['Probe Number'] }"
                    @mouseenter="e => hoverTableData = data"
                  >
                    <a class="container-block row-block" :style="{ flex: 1 }" @click="e => false && (selectedTableData = data)">
                      <div class="bar"></div>
                      <div
                        v-for="(option, index) in tableOptions"
                        :key="index"
                        class="td row-block"
                        :class="(option.class || (() => []))(data[option.value], dindex, data)"
                        :style="{ width: tableWidths[index].value + tableWidths[index].grab - (!tableOptions[index + 1] && tableOverflow ? scrollbarSize : 0) + 'px' }"
                      >
                        <template>
                          <span
                            :style="(option.style || (() => ({})))(data[option.value], dindex, data)"
                            :title="((option.display || (x => x))(data[option.value], dindex, data) || '').replace(/\<.+?\>/g, '')"
                            v-html="(option.display || (x => x))(data[option.value], dindex, data) || option.empty || '- -'"
                          ></span>
                        </template>
                        <template v-if="option.sortMap !== null && (option.class || (() => []))(data[option.value], dindex, data).includes('center') && !(option.class || (() => []))(data[option.value], dindex, data).includes('auto-width')">
                          <div :style="{ width: '5px' }"></div>
                          <i :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.sortValue || option.value)] || '')]" aria-hidden="true" :style="{ opacity: 0 }"></i>
                        </template>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import customGrab from '../../mixins/customGrab.vue'
import responsitive from '../../mixins/responsitive.vue'
import { groupBy, sortData } from '../../constants/global/util'

export default {
  mixins: [
    customGrab,
    responsitive
  ],
  props: {
    panelData: {
      type: Object,
      required: true
    },
    selectData: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      selectedTableData: null,
      hoverTableData: null,
      // table
      tableTopWidths: null,
      tableWidths: null,
      tableMinWidths: null,
      tableOverflow: false,
      staticTableWidths: [
        [
        ],
        [
        ]
      ],
      sort: {
        disabled: false,
        value: [],
        order: []
      },
      // grab
      boardType: {
        'board1': 'line'
      },
      boardData: {
        'board1': {
          onStart: this.boardResponse('board1', 'start'),
          onMove: this.boardResponse('board1', 'move'),
          onEnd: this.boardResponse('board1', 'end')
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'scrollState'
    ]),
    filtedDatas () {
      return this.panelData.fragment_table || []
    },
    tableDatas () {
      let tableDatas = this.filtedDatas
      tableDatas = sortData(
        tableDatas,
        this.sort.value.map(x => this.sortMap[x]),
        this.sort.order.map(x => x.replace('-', ''))
      )
      tableDatas = groupBy(tableDatas, () => 'default').map(datas => ({ title: datas[0].group, isGroup: true, datas: datas }))
      return tableDatas
    },
    sortMap () {
      return this.tableOptions.reduce((s, c) => ({ ...s, ...{ [c.value]: c.sortMap || c.value } }), {})
    },
    // static
    topTableOptions () {
      return [
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Prob_Information'),
          class: () => ['center'],
          background: '#E2F3FA',
          length: 5,
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Comparison_Reference_Samples'),
          class: () => ['center'],
          background: '#EDFAE0',
          length: 3,
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.topTitle.___Sample_Results'),
          class: () => ['center'],
          background: '#FFF5E2',
          length: 3,
          sortMap: null
        }
      ]
    },
    tableOptions () {
      return [
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Probe_No'),
          value: 'Probe Number',
          display: value => value,
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Function'),
          value: 'Function',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Location'),
          value: 'Location (kb)',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Gene'),
          value: 'Gene',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Exon'),
          value: 'Exon',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___CN_Exp'),
          value: 'CN Exp',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Ref_95'),
          value: 'Ref. 95%',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Exp_Range'),
          value: 'Exp. Range',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Result'),
          value: 'Result',
          class: () => ['center'],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Aberrant'),
          value: 'Aberrant',
          display: value => ({
            'true': 'Yes',
            'true?': 'Yes?',
            'false': 'no'
          }[value] || value),
          class: value => [
            'center',
            {
              'true': 'alert',
              'true?': 'empty',
              'Yes': 'alert',
              'Yes?': 'empty'
            }[value]
          ],
          sortMap: null
        },
        {
          title: this.$t('COMPONENT.digitalMLPA.mainDataTable.table.title.___Quality_issue'),
          value: 'Quality Issue',
          class: () => ['center'],
          sortMap: null
        }
      ]
    }
  },
  watch: {
    // data
    'selectedTableData' (nv, ov) {
      if (nv !== ov && JSON.stringify(nv) !== JSON.stringify(ov)) {
        this.selectedTableData = nv ? JSON.parse(JSON.stringify(nv)) : null
      }
    },
    'hoverTableData' (nv) {
      this.$emit('select', nv)
    },
    'selectData' (nv) {
      if (nv) {
        let index = this.filtedDatas.indexOf(this.filtedDatas.find(data => data['Probe Number'] === nv['Probe Number']))
        if ((!this.hoverTableData) || (nv['Probe Number'] !== this.hoverTableData['Probe Number'])) {
          this.$refs['custom-table-scroll'].scrollTo({
            top: index * 31 - (300 / 2) + (30 / 2)
          })
        }
      }
    },
    // table
    'tableDatas' () {
      this.getTableOverflow()
    },
    'windowWidth' (nv) {
      this.getTableWidths(nv)
      this.getTableOverflow()
    }
  },
  methods: {
    // table
    getTableOverflow () {
      setTimeout(() => {
        let scrollContainer = this.$refs['custom-table-scroll']
        if (scrollContainer) {
          this.tableOverflow = scrollContainer.scrollHeight > scrollContainer.offsetHeight
        }
      })
    },
    getTableWidths (windowWidth) {
      window.dispatchEvent(new Event('scroll'))
      let tableWidth = Math.min(windowWidth * 0.95, 1208) - (22 * 2) - (this.scrollState.height ? this.scrollbarSize : 0)
      tableWidth = tableWidth - this.staticTableWidths[0].reduce((s, c) => s + c, 0) - this.staticTableWidths[1].reduce((s, c) => s + c, 0)
      let tableWidths = this.tableWidths || [
        ...this.staticTableWidths[0],
        100,
        85,
        115,
        115,
        75,
        105,
        115,
        95,
        85,
        105,
        145,
        ...this.staticTableWidths[1]
      ].map(width => ({
        value: width
      }))
      let tableMinWidths = this.tableMinWidths || 0.1
      tableWidths = tableWidths.slice(this.staticTableWidths[0].length, tableWidths.length - this.staticTableWidths[1].length)
      let ratio = tableWidth / tableWidths.reduce((s, c) => s + c.value, 0)
      tableWidths = Array.prototype.concat.apply([], [
        this.staticTableWidths[0].map(width => ({
          value: width,
          grab: 0
        })),
        tableWidths.map(width => ({
          value: width.value * ratio,
          grab: 0
        })),
        this.staticTableWidths[1].map(width => ({
          value: width,
          grab: 0
        }))
      ])
      this.tableMinWidths = tableMinWidths * ratio
      this.tableTopWidths = this.getTopTableWidths(tableWidths)
      this.tableWidths = tableWidths
    },
    getTopTableWidths (tableWidths) {
      let position = 0
      return this.topTableOptions.map(option => {
        let length = option.length
        let result = tableWidths.slice(position, position + length).reduce((a, b) => ({
          value: a.value + (b.value || 0),
          grab: a.grab + (b.grab || 0)
        }), { value: 0, grab: 0 })
        position += length
        return result
      })
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
    },
    // grab
    boardResponse (id, type) {
      return {
        'board1': {
          'start': boardData => {
            this.sort.disabled = true
          },
          'move': boardData => {
            if (this.boardType['board1'] === 'grab') {
              let grabID = this.boardData[id].grabID
              let tableWidths = [...this.tableWidths]
              let result = boardData.grabX - boardData.baseX
              let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
              tableWidths.forEach((_, i) => {
                if (i === grabID) {
                  tableWidths[i].grab = result
                } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                  tableWidths[i].grab = -(result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase))
                }
              })
              this.tableWidths = tableWidths
            }
          },
          'end': boardData => {
            let grabID = this.boardData[id].grabID
            let tableWidths = [...this.tableWidths]
            let result = boardData.grabX - boardData.baseX
            let ratioBase = tableWidths.slice(grabID + 1, tableWidths.length - this.staticTableWidths[1].length).reduce((s, c, i) => s + c.value - (this.tableOptions[i].minWidth || this.tableMinWidths), 0)
            tableWidths.forEach((_, i) => {
              tableWidths[i].grab = 0
              if (i === grabID) {
                tableWidths[i].value += result
              } if (i > grabID && i + this.staticTableWidths[1].length < tableWidths.length) {
                tableWidths[i].value -= result * ((tableWidths[i].value - (this.tableOptions[i].minWidth || this.tableMinWidths)) / ratioBase)
              }
            })
            this.tableWidths = tableWidths
            setTimeout(() => { this.sort.disabled = false })
          }
        }
      }[id][type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/digitalMLPA/mainDataTable.vue